import React, { useContext } from "react";
import { CartContext } from "../Component/CartContext";
import productData from "../Datas/productData";
import "../css/cartpage.scss";
import { Link, useNavigate } from "react-router-dom";

const formatPrice = (price) => Number(price).toFixed(2);

const CartPage = () => {
  const navigate = useNavigate();
  const { cartItems, removeFromCart, updateQuantity } = useContext(CartContext);

  const getProductById = (id) => {
    return productData.find((product) => product.id === id);
  };

  const calculateTotal = () => {
    let total = 0;
    cartItems.forEach((item) => {
      const product = getProductById(item.id);
      if (product) {
        const price = parseFloat(product.price.replace(/,/g, ""));
        total += price * item.quantity;
      }
    });
    return total;
  };

  const subtotal = calculateTotal();

  const handleUpdateQuantity = (id, size, color, newQuantity) => {
    if (newQuantity > 0) {
      updateQuantity(id, size, color, newQuantity);
    }
  };

  const handleCheckout = () => {
    if (cartItems.length > 0) {
      navigate("/checkout");
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      alert("Your cart is empty");
    }
  };

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (cartItems.length === 0) {
    return (
      <div className="cart-page">
        <div className="cart-page__empty">
          <h1>Cart</h1>
          <p>Your cart is currently empty.</p>
          <Link to="/shop" onClick={toTop}>
            Continue shopping
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="cart-page">
      <div className="cart-page__container">
        <h1 className="cart-page__title">Cart</h1>

        <div className="cart-page__table-head">
          <span>Product</span>
          <span>Quantity</span>
          <span>Total</span>
        </div>

        <div className="cart-page__items">
          {cartItems.map((item) => {
            const product = getProductById(item.id);

            if (!product) {
              return null;
            }

            const unitPrice = Number(product.price);
            const lineTotal = unitPrice * item.quantity;

            return (
              <div
                className="cart-page__item"
                key={`${item.id}-${item.size}-${item.color}`}
              >
                <div className="cart-page__product">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="cart-page__product-image"
                  />

                  <div className="cart-page__product-info">
                    <Link
                      to={`/shopDetails/${product.id}`}
                      onClick={toTop}
                      className="cart-page__product-name"
                    >
                      {product.name}
                    </Link>
                    <p className="cart-page__product-price">
                      ${formatPrice(unitPrice)}
                    </p>
                    <p className="cart-page__product-size">
                      {(item.size || "").toUpperCase()}-
                      {(item.color || "").toUpperCase()}
                    </p>
                  </div>
                </div>

                <div className="cart-page__quantity">
                  <div className="cart-page__quantity-box">
                    <button
                      type="button"
                      onClick={() =>
                        handleUpdateQuantity(
                          item.id,
                          item.size,
                          item.color,
                          item.quantity - 1
                        )
                      }
                    >
                      -
                    </button>
                    <span>{item.quantity}</span>
                    <button
                      type="button"
                      onClick={() =>
                        handleUpdateQuantity(
                          item.id,
                          item.size,
                          item.color,
                          item.quantity + 1
                        )
                      }
                    >
                      +
                    </button>
                  </div>
                  <button
                    type="button"
                    className="cart-page__remove"
                    onClick={() =>
                      removeFromCart(item.id, item.size, item.color)
                    }
                  >
                    Remove
                  </button>
                </div>

                <div className="cart-page__line-total">
                  ${formatPrice(lineTotal)}
                </div>
              </div>
            );
          })}
        </div>

        <div className="cart-page__footer">
          <div className="cart-page__note">
            <label htmlFor="order-note">Add order note</label>
            <textarea id="order-note" placeholder="How can we help you?" />
          </div>

          <div className="cart-page__summary">
            <p className="cart-page__summary-total">
              Total: <span>${formatPrice(subtotal)} USD</span>
            </p>
            <p className="cart-page__summary-tax">
              Taxes and <u>shipping</u> calculated at checkout
            </p>
            <button
              type="button"
              className="cart-page__checkout"
              onClick={handleCheckout}
            >
              CHECKOUT
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartPage;
